export function isValidURL(value: string): boolean {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > 2048) return false;
  if (/\s/.test(trimmed)) return false;

  try {
    const url = new URL(trimmed);
    const host = url.hostname;

    // Special case: allow localhost
    if (host === "localhost") return true;

    // Reject purely numeric hostnames (like "1", "123", etc.)
    if (/^\d+$/.test(host)) return false;

    // Special case: allow valid IPv4 addresses
    const ipv4Regex = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
    const ipMatch = host.match(ipv4Regex);
    if (ipMatch) {
      // Check each octet is between 0-255
      const octets = ipMatch.slice(1).map(Number);
      if (octets.every((octet) => octet >= 0 && octet <= 255)) {
        return true;
      }
      return false;
    }

    // For other domains, require at least one dot
    if (!host.includes(".")) return false;

    // Reject hosts whose labels are all-numeric (e.g. "12345" or "123.456")
    const labels = host.split(".");
    if (labels.every((l) => /^\d+$/.test(l))) return false;

    // Basic TLD sanity: last label must have a letter and be length >= 2
    const tld = labels[labels.length - 1];
    if (tld.length < 2 || !/[a-zA-Z]/.test(tld)) return false;

    return true;
  } catch {
    return false;
  }
}
